import React from "react";
import { ColorButton } from "../../components/common/CustomButton";
import Axios from "axios";
import "../../styles/css/InfoBoxQuarentine.css";

Date.prototype.hhmmddmm = function () {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();
  var hour = this.getHours();
  var min = this.getMinutes();
  return (
    (hour > 9 ? "" : "0") +
    hour +
    ":" +
    (min > 9 ? "" : "0") +
    min +
    " (" +
    (dd > 9 ? "" : "0") +
    dd +
    "/" +
    (mm > 9 ? "" : "0") +
    mm +
    ")"
  );
};

export default function InfoBox(props) {
  const movementDescription = (movement) => {
    if (movement === undefined) return "Actividad desconocida";
    if (movement.type === "VISIT") {
      if (movement.placeName !== undefined)
        return (
          "En " +
          movement.placeName +
          " desde las " +
          new Date(movement.startTime).hhmmddmm()
        );
      else
        return (
          "En un lugar nuevo desde las " +
          new Date(movement.startTime).hhmmddmm()
        );
    } else if (movement.type == "COMMUTE") {
      return "Viajando desde las " + new Date(movement.startTime).hhmmddmm();
    }
  };

  const batteryDescription = (batteryStatus) => {
    if (batteryStatus === undefined)
      return <p>'Se desconoce el estado de la bateria'</p>;
    return (
      "Bateria: " +
      batteryStatus.batteryLevel +
      "%" +
      (batteryStatus.charging ? " (cargando)" : "")
    );
  };

  const ringModeDescription = (ringMode) => {
    if (ringMode === undefined) return "Se desconoce el perfil de sonido";

    if (ringMode.ringMode === "SILENT") {
      return "Perfil de sonido: Silencio";
    } else if (ringMode.ringMode === "VIBRATE") {
      return "Perfil de sonido: Vibración";
    } else if (ringMode.ringMode === "SOUND") {
      return "Perfil de sonido: " + ringMode.level + "%";
    }

    return "Se desconoce el perfil de sonido";
  };

  const lastUpdateDescriptio = (userState) => {
    if (userState == null)
      return "Sin datos";

    var diff = new Date().getTime() - userState.reportTime;
    var minutes = Math.floor(diff / 1000 / 60);
    if (minutes < 60) return "Actualizado hace " + minutes + " minutos";
    else {
      var horas = Math.floor(minutes / 60);
      return "Actualizado hace " + horas + " horas";
    }
  };

  const lastUse = (userState) => {
    if (userState.phoneUsage.lastScreenOff !== undefined) {
      var diff = new Date().getTime() - userState.phoneUsage.lastScreenOff;
      var minutes = Math.floor(diff / 1000 / 60);
      if (minutes < 60)
        return "Ultimo uso del celular hace " + minutes + " minutos";
      else {
        var horas = Math.floor(minutes / 60);
        return "Ultimo uso del celular hace " + horas + " horas";
      }
    }
  };

  return (
    <div className="infoBox">
      <h1>
        {props.name} {props.lastName}{" "}
      </h1>
      <h2>{lastUpdateDescriptio(props.userState)}</h2>

      {props.pingButton ? (
        <ColorButton
          className="buttonPingAction"
          onClick={() => props.pingAction(props.userState.userId)}
        >
          {" "}
          FORZAR ACTUALIZACION{" "}
        </ColorButton>
      ) : null}

      {props.userState ? (
        <div>
          <p>{movementDescription(props.userState.currentMovement)}</p> 
          <p>{batteryDescription(props.userState.batteryStatus)}</p>
          <p>{ringModeDescription(props.userState.ringMode)}</p>
          <p>{lastUse(props.userState)}</p>
        </div>
      ) : null }
    </div>
  );
}
